import { dateLabel, monthLabel, UNDERSTANDING } from "@/lib/format";
import { Star } from "lucide-react";
import { Sheet, Footer } from "@/components/PrintDocs";

export function LaporanPerkembangan({ settings, row, month }) {
  if (!row) return <div className="p-8 text-center text-slate-400">Pilih siswa dengan jurnal pada bulan ini.</div>;
  const und = row.understanding || {};
  return (
    <Sheet size="laporan-jurnal" testId="laporan-perkembangan-doc" className="text-sm">
      <div className="flex items-center gap-4 border-b-4 border-orange-400 pb-4 mb-5">
        <img src="/mascot.png" alt="logo" className="h-16 w-16 object-contain" />
        <div>
          <div className="font-display text-2xl font-bold text-[#1e2a78]"><span className="text-orange-500">Bimbel</span> {(settings?.name || "Bimbel Gemma").replace(/^bimbel\s*/i, "")}</div>
          <div className="text-xs text-slate-400">{settings?.address} · {settings?.phone}</div>
        </div>
      </div>
      <div className="text-center mb-5">
        <div className="inline-block px-6 py-1.5 rounded-full bg-violet-100 text-violet-600 font-display font-bold text-lg">LAPORAN PERKEMBANGAN BELAJAR</div>
        <div className="text-sm text-slate-500 mt-1">Periode: {monthLabel(month)}</div>
      </div>
      <div className="flex items-center gap-4 mb-5 p-4 rounded-2xl bg-amber-50">
        <div className="w-14 h-14 rounded-2xl overflow-hidden bg-gradient-to-br from-orange-400 to-amber-500 flex items-center justify-center text-white font-display text-2xl font-bold">{row.photo ? <img src={`${process.env.REACT_APP_BACKEND_URL}${row.photo}`} alt="" className="w-full h-full object-cover" /> : row.name.charAt(0)}</div>
        <div className="flex-1">
          <div className="font-display text-xl font-bold">{row.name}</div>
          <div className="text-slate-500">{row.class_label || row.level}</div>
        </div>
        <div className="grid grid-cols-4 gap-2 text-center">
          {[["Pertemuan", row.count], ["Rata-rata ⭐", row.avg_rating], ["Paham", und.paham || 0], ["Perlu Diulang", und.ulang || 0]].map(([k, v]) => (
            <div key={k} className="px-3 py-2 rounded-xl bg-white border border-amber-100"><div className="font-display text-lg font-bold">{v}</div><div className="text-[10px] text-slate-500">{k}</div></div>
          ))}
        </div>
      </div>
      <table className="w-full">
        <thead><tr className="bg-violet-50 text-violet-700 text-xs">
          <th className="py-2 px-2 text-left">Tanggal</th><th className="py-2 px-2 text-left">Materi</th><th className="py-2 px-2 text-left">PR / Tugas</th><th className="py-2 px-2 text-left">Catatan Guru</th><th className="py-2 px-2 text-center">Pemahaman</th><th className="py-2 px-2 text-center">Bintang</th>
        </tr></thead>
        <tbody>
          {row.journals.map((j) => (
            <tr key={j.id} className="border-b border-slate-100 align-top">
              <td className="py-2 px-2 whitespace-nowrap">{dateLabel(j.date)}</td>
              <td className="py-2 px-2 font-medium">{j.material}</td>
              <td className="py-2 px-2 text-slate-600">{j.homework || "-"}</td>
              <td className="py-2 px-2 text-slate-600 italic">{j.teacher_note || "-"}</td>
              <td className="py-2 px-2 text-center"><span className={`px-2 py-0.5 rounded-full text-[11px] border ${UNDERSTANDING[j.understanding || "paham"].cls}`}>{UNDERSTANDING[j.understanding || "paham"].label}</span></td>
              <td className="py-2 px-2 text-center whitespace-nowrap"><span className="inline-flex">{[1,2,3,4,5].map((i) => <Star key={i} className={`w-3.5 h-3.5 ${i <= j.rating ? "fill-amber-400 text-amber-400" : "text-slate-200"}`} />)}</span></td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex justify-end mt-8 text-sm">
        <div className="text-center">
          <div className="text-slate-500 mb-10">Pengajar</div>
          <div className="font-display font-bold border-t-2 border-slate-300 pt-1 px-6">{(settings?.teachers || [])[0]?.name || "Pengajar"}</div>
        </div>
      </div>
      <Footer settings={settings} />
    </Sheet>
  );
}
